import { render, staticRenderFns } from "./mainLayout.vue?vue&type=template&id=acbd79a2&scoped=true"
import script from "./mainLayout.vue?vue&type=script&lang=js"
export * from "./mainLayout.vue?vue&type=script&lang=js"
import style0 from "./mainLayout.vue?vue&type=style&index=0&id=acbd79a2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "acbd79a2",
  null
  
)

export default component.exports